// Tickable Mail: flows texts (nl)
export default {
  "mail_flow_filter_exclude_events": "Niet voor deze activiteiten",
  "mail_flow_no_exceptions": "Geen uitzonderingen",
  "mail_flow_filter_except_events": "behalve bij {names}",
  "mail_flow_how_it_works": "Hoe werkt dit?",
  "mail_flow_filter_toggle": "Alleen voor bepaalde bezoekers",
  "mail_flow_turn_on": "Aanzetten",
  "mail_flow_turn_off": "Uitzetten",
  "mail_flow_go_live": "Wijzigingen live zetten",
  "mail_flow_state_on": "Staat aan",
  "mail_flow_state_off": "Staat uit",
  "mail_flow_state_saving": "bezig met bewaren",
  "mail_flow_state_changes": "wijzigingen nog niet live",
  "mail_event_reminder": "Herinnering vooraf",
  "mail_event_reminder_text": "Twee dagen voor het bezoek alles op een rij.",
  "mail_event_thanks": "Bedankje na afloop",
  "mail_event_thanks_text": "Een bedankje, alleen voor wie er echt was.",
  "mail_event_adjust": "Aanpassen",
  // list
  "mail_flow_list_intro": "Mails die vanzelf gaan: een herinnering vlak voor het bezoek, een bedankje na afloop. Alles rekent vanaf het tijdslot van elke bestelling.",
  "mail_flow_new": "Nieuwe automatische mail",
  "mail_flow_list_empty_title": "Nog geen automatische mails",
  "mail_flow_list_empty_detail": "Begin met een herinnering vlak voor het bezoek. Die staat in een minuut klaar.",
  "mail_flow_load_failed": "De automatische mails laden lukte niet.",
  "mail_flow_retry": "Opnieuw proberen",
  "mail_flow_has_changes": "Wijzigingen nog niet live",
  "mail_flow_toggle_label": "{name} aan of uit",
  "mail_flow_delete_label": "{name} verwijderen",
  "mail_flow_delete_title": "Automatische mail verwijderen?",
  "mail_flow_delete_message": "{name} verdwijnt, samen met wie erin liep. Verstuurde mails blijven gewoon in je overzicht staan.",
  "mail_flow_delete_waiting": "Er loopt nog {n} persoon in {name}. Die krijgt hierna niks meer uit deze automatische mail. | Er lopen nog {n} mensen in {name}. Die krijgen hierna niks meer uit deze automatische mail.",
  "mail_flow_delete_accept": "Verwijderen",
  "mail_flow_delete_failed": "Verwijderen lukte niet",
  "mail_flow_readonly": "Je kunt automatische mails bekijken, maar niet aanpassen. Vraag de eigenaar van je organisatie om het recht 'Mail bewerken'.",

  // new
  "mail_flow_new_title": "Nieuwe automatische mail",
  "mail_flow_new_start_from": "Waar wil je mee beginnen?",
  "mail_flow_new_template_standard": "Laat je het leeg, dan krijg je de standaardmail. Die kun je daarna aanpassen.",
  "mail_flow_send_standard": "De standaardmail",
  "mail_flow_new_template_later": "Weet je het nog niet? Laat het leeg, je kiest de mail later in de editor.",
  "mail_flow_new_create": "Maken",
  "mail_flow_create_failed": "Maken lukte niet",
  "mail_flow_starter_reminder": "Herinnering vooraf",
  "mail_flow_starter_reminder_text": "2 dagen voor het bezoek om 10:00 een mail met alles op een rij.",
  "mail_flow_starter_thanks": "Bedankje na afloop",
  "mail_flow_starter_thanks_text": "3 uur na de eerste scan een bedankje, alleen voor wie er echt was.",
  "mail_flow_starter_payment_reminder": "Betaalherinnering",
  "mail_flow_starter_payment_reminder_text": "24 uur voor een reservering verloopt een herinnering als hij nog niet betaald is, plus een melding aan jou.",
  "mail_flow_starter_welcome": "Welkom na aanmelden",
  "mail_flow_starter_welcome_text": "Een welkomstmail zodra iemand zich aanmeldt voor je nieuws.",
  "mail_flow_starter_empty": "Leeg",
  "mail_flow_starter_empty_text": "Je bouwt hem zelf op, stap voor stap.",

  // editor
  "mail_flow_not_found": "Deze automatische mail bestaat niet (meer)",
  "mail_flow_not_found_detail": "Misschien heeft iemand hem verwijderd, of hoort hij bij een andere organisatie.",
  "mail_flow_back_to_list": "Naar je automatische mails",
  "mail_flow_name": "Naam",
  "mail_flow_name_required": "Geef je automatische mail een naam",
  "mail_flow_save": "Opslaan",
  "mail_flow_save_failed": "Opslaan lukte niet",
  "mail_flow_publish": "Live zetten",
  "mail_flow_publish_failed": "Live zetten lukte niet",
  "mail_flow_published_live": "Live gezet. Geldt voor bestellingen vanaf nu",
  "mail_flow_published_others": "{n} persoon loopt nog in de vorige versie | {n} mensen lopen nog in de vorige versie",
  "mail_flow_unsaved": "Je hebt wijzigingen die nog niet zijn opgeslagen. Toch weggaan?",
  "mail_flow_empty_title": "Voeg je eerste stap toe",
  "mail_flow_empty_detail": "Bijvoorbeeld: wacht tot 2 dagen voor het bezoek, en stuur dan een herinnering.",
  "mail_flow_add_first_step": "Stap toevoegen",
  "mail_flow_add_after": "Stap toevoegen na: {step}",
  "mail_flow_add_in_branch": "Stap toevoegen onder {branch}",
  "mail_flow_moved": "Verplaatst: {step}. Nu stap {n} van {total}.",
  "mail_flow_limits": "{steps} van {maxSteps} stappen · {sends} van {maxSends} mails",
  "mail_flow_limit_steps_hint": "Een automatische mail heeft maximaal {max} stappen",
  "mail_flow_limit_sends_hint": "Een automatische mail stuurt maximaal {max} mails",
  "mail_flow_add_if_middle_hint": "De stappen hieronder komen onder Ja",
  "mail_flow_add_exit_middle_hint": "Stoppen kan alleen onderaan",
  "mail_flow_keyboard_hint": "Met het toetsenbord: Enter opent een stap, Delete verwijdert hem, Alt + pijltje verplaatst hem.",
  "mail_flow_panel_trigger": "Wie komt erin",
  "mail_flow_close": "Sluiten",
  "mail_flow_cancel": "Terug",
  "mail_flow_yes": "Ja",
  "mail_flow_no": "Nee",
  "mail_flow_branch_empty": "hier stopt het",
  "mail_flow_remove_title": "Stap verwijderen?",
  "mail_flow_new_other_mail": "Andere mail kiezen",
  "mail_flow_removed": "\"{step}\" is weggehaald.",
  "mail_flow_wait_add_hours": "Uren en minuten",
  "mail_flow_tag_placeholder_enter": "Typ een tag en druk op Enter",
  "mail_flow_remove_if_message": "Deze voorwaarde verdwijnt, en de stap onder Ja en Nee ook. | Deze voorwaarde verdwijnt, en ook de {n} stappen onder Ja en Nee.",
  "mail_flow_remove_accept": "Verwijderen",
  "mail_flow_step_remove": "Stap verwijderen",
  "mail_flow_problem_no_template": "Kies een mail",
  "mail_flow_problem_no_rules": "Voeg een voorwaarde toe",
  "mail_flow_problem_no_tag": "Kies welke tag het startsein is",

  // on / off
  "mail_flow_turned_on": "Staat aan",
  "mail_flow_off_title": "Uitzetten?",
  "mail_flow_off_waiting": "1 persoon wacht nog op deze mail. Die krijgt hem dan niet. | {n} mensen wachten nog op deze mail. Die krijgen hem dan niet.",
  "mail_flow_on_title": "{name} aanzetten",
  "mail_flow_on_existing": "Ook voor die ene persoon die al tickets heeft | Ook voor de {n} mensen die al tickets hebben",
  "mail_flow_on_first": "De eerste gaat {day} om {time}",
  "mail_flow_turned_on_existing": "Ook 1 persoon die al tickets had, krijgt hem. | Ook {n} mensen die al tickets hadden, krijgen hem.",
  "mail_flow_enroll_failed": "Hij staat aan, maar wie al tickets had kwam er niet bij. Zet hem uit en weer aan om het nog eens te proberen.",

  "mail_flow_trigger_locked": "Zet hem eerst uit als je dit wilt veranderen.",
  "mail_flow_back_to_flow": "Terug naar de automatische mail",
  "mail_flow_new_mail_name": "Nieuwe mail",
  "mail_flow_toggle_failed": "Aan- of uitzetten lukte niet",

  // counts
  "mail_flow_count_waiting": "{n} wacht | {n} wachten",
  "mail_flow_count_waiting_here": "{n} wacht hier | {n} wachten hier",
  "mail_flow_count_done": "{n} klaar | {n} klaar",
  "mail_flow_count_sent": "{n} verstuurd | {n} verstuurd",
  "mail_flow_count_skipped": "{n} overgeslagen | {n} overgeslagen",

  // step types
  "mail_flow_type_send": "Mail",
  "mail_flow_type_wait": "Wacht",
  "mail_flow_type_if": "Als…",
  "mail_flow_type_tag": "Tag",
  "mail_flow_type_notify_team": "Melding aan je team",
  "mail_flow_type_exit": "Stop",

  // step texts
  "mail_flow_step_send_text": "Stuur: {name}",
  "mail_flow_step_send_empty": "Stuur: nog geen mail gekozen",
  "mail_flow_template_missing": "een mail die niet meer bestaat",
  "mail_flow_step_if_text": "Als: {condition}",
  "mail_flow_condition_empty": "nog geen voorwaarde",
  "mail_flow_step_tag_add": "Geef tag {tags}",
  "mail_flow_step_tag_remove": "haal tag {tags} weg",
  "mail_flow_step_tag_empty": "Tag: nog niks ingesteld",
  "mail_flow_step_notify_text": "Stuur je team een melding",
  "mail_flow_step_exit_text": "Stop",
  "mail_flow_no_steps_short": "nog geen stappen",
  "mail_flow_and": "en",
  "mail_flow_or": "of",
  "mail_flow_unknown_item": "(verwijderd)",
  "mail_flow_n_more": "nog {n} | nog {n}",
  "mail_flow_n_days": "{n} dag | {n} dagen",
  "mail_flow_n_hours": "{n} uur | {n} uur",
  "mail_flow_n_minutes": "{n} minuut | {n} minuten",

  // wait texts
  "mail_flow_wait_for": "Wacht {duration}",
  "mail_flow_wait_for_at": "Wacht {duration}, en dan tot {time}",
  "mail_flow_wait_until_time": "Wacht tot het {time} is",
  "mail_flow_wait_nothing": "Wacht: nog niks ingesteld",
  "mail_flow_wait_days_before_visit": "Wacht tot {days} voor het bezoek, om {time}",
  "mail_flow_wait_visit_day": "Wacht tot de dag van het bezoek, om {time}",
  "mail_flow_wait_after_first_scan": "Wacht tot {hours} na de eerste scan",
  "mail_flow_wait_after_visit_end": "Wacht tot {days} na het bezoek, om {time}",
  "mail_flow_wait_before_reservation_expires": "Wacht tot {hours} voordat de reservering verloopt",

  // wait panel
  "mail_flow_wait_how": "Hoe lang wachten?",
  "mail_flow_wait_mode_for": "Een vaste tijd",
  "mail_flow_wait_mode_visit": "Rond het bezoek",
  "mail_flow_wait_visit_needs_order": "Wachten rond het bezoek kan alleen als de automatische mail met een bestelling begint.",
  "mail_flow_unit_days": "Dagen",
  "mail_flow_unit_hours": "Uren",
  "mail_flow_unit_minutes": "Minuten",
  "mail_flow_wait_at_time_toggle": "Daarna wachten tot een vast tijdstip",
  "mail_flow_wait_time": "Tijdstip",
  "mail_flow_wait_for_hint": "Met een vast tijdstip gaat de volgende stap op het eerstvolgende moment dat het zo laat is. Handig om niemand midden in de nacht te mailen.",
  "mail_flow_wait_until_label": "Tot wanneer?",
  "mail_flow_until_days_before_visit": "Een aantal dagen voor het bezoek",
  "mail_flow_until_after_first_scan": "Een aantal uur na de eerste scan",
  "mail_flow_until_after_visit_end": "Een aantal dagen na het bezoek",
  "mail_flow_until_before_reservation_expires": "Een aantal uur voordat de reservering verloopt",
  "mail_flow_until_days_before_visit_hint": "We rekenen vanaf het tijdslot van elke bestelling. Heb je 300 tijdsloten, dan krijgt iedereen de herinnering voor zijn eigen bezoek, en verschuif je een slot, dan schuift de herinnering mee. Bij tickets die meerdere dagen geldig zijn slaan we deze herinnering over. Een bestelling zonder tijdslot doet niet mee.",
  "mail_flow_until_after_first_scan_hint": "Het moment is de eerste scan van de bestelling, dus bij open museumtickets het echte bezoek. Niet gescand? Dan rekenen we vanaf het einde van het tijdslot, maar alleen bij tickets voor één dag. Zo krijgt ook wie niet scant een bedankje. Wil je no-shows overslaan, zet er dan 'Als: gescand' onder.",
  "mail_flow_until_after_visit_end_hint": "We rekenen vanaf het einde van het tijdslot van de bestelling. Bij tickets die meerdere dagen geldig zijn slaan we dit over.",
  "mail_flow_until_before_reservation_expires_hint": "Voor reserveringen met een betaaltermijn. Is de reservering al betaald, dan kun je dat met een 'Als…' eronder afvangen.",
  "mail_flow_wait_missed_hint": "Is dit moment al voorbij als iemand hier aankomt, bijvoorbeeld omdat hij vandaag bestelt voor morgen? Dan slaan we de mail direct hierna over.",

  // send panel
  "mail_flow_send_which": "Welke mail?",
  "mail_flow_send_pick": "Kies een mail",
  "mail_flow_send_pick_hint": "Kies een mail, anders kun je niet live zetten.",
  "mail_flow_send_no_templates": "Je hebt nog geen mails. Maak er eerst een.",
  "mail_flow_send_marketing_hint": "Dit is een nieuwsmail. Die gaat alleen naar mensen die toestemming gaven, en hooguit één per dag naar hetzelfde adres.",
  "mail_flow_send_edit": "Deze mail bewerken",
  "mail_flow_send_new": "Nieuwe mail maken",

  // if panel
  "mail_flow_if_when": "Wanneer is het Ja?",
  "mail_flow_op_all": "Alles klopt",
  "mail_flow_op_any": "Eén ervan klopt",
  "mail_flow_rule_type": "Voorwaarde",
  "mail_flow_rule_not": "Wel of niet",
  "mail_flow_rule_is": "Wel",
  "mail_flow_rule_is_not": "Niet",
  "mail_flow_rule_remove": "Voorwaarde verwijderen",
  "mail_flow_rule_add": "Voorwaarde toevoegen",
  "mail_flow_rule_compare": "Vergelijking",
  "mail_flow_rule_days": "Aantal dagen",
  "mail_flow_days_word": "dagen",
  "mail_flow_compare_lt": "minder dan",
  "mail_flow_compare_lte": "hooguit",
  "mail_flow_compare_gt": "meer dan",
  "mail_flow_compare_gte": "minstens",
  "mail_flow_if_hint": "Ja en Nee gaan elk hun eigen weg en komen niet meer samen. Laat je een kant leeg, dan stopt het daar.",
  "mail_flow_pick_ticket_types": "Kies tickettypes",
  "mail_flow_pick_events": "Kies activiteiten",
  "mail_flow_pick_language": "Kies een taal",
  "mail_flow_rule_scanned": "Gescand",
  "mail_flow_rule_ticket_type": "Tickettype",
  "mail_flow_rule_event": "Activiteit",
  "mail_flow_rule_refunded": "Terugbetaald",
  "mail_flow_rule_language": "Taal",
  "mail_flow_rule_has_tag": "Heeft een tag",
  "mail_flow_rule_has_consent": "Toestemming voor nieuwsmail",
  "mail_flow_rule_has_other_future_event": "Ook tickets voor een andere activiteit",
  "mail_flow_rule_days_until_visit": "Dagen tot het bezoek",
  "mail_flow_rule_reservation_paid": "Reservering betaald",
  "mail_flow_rule_scanned_text": "gescand",
  "mail_flow_rule_scanned_not_text": "niet gescand",
  "mail_flow_rule_refunded_text": "(deels) terugbetaald",
  "mail_flow_rule_refunded_not_text": "niet terugbetaald",
  "mail_flow_rule_has_consent_text": "heeft toestemming voor nieuwsmail",
  "mail_flow_rule_has_consent_not_text": "geen toestemming voor nieuwsmail",
  "mail_flow_rule_has_other_future_event_text": "heeft ook tickets voor een andere, latere activiteit",
  "mail_flow_rule_has_other_future_event_not_text": "geen tickets voor een andere, latere activiteit",
  "mail_flow_rule_reservation_paid_text": "reservering betaald",
  "mail_flow_rule_reservation_paid_not_text": "reservering nog niet betaald",
  "mail_flow_rule_ticket_type_text": "met ticket {names}",
  "mail_flow_rule_ticket_type_not_text": "zonder ticket {names}",
  "mail_flow_rule_event_text": "voor {names}",
  "mail_flow_rule_event_not_text": "niet voor {names}",
  "mail_flow_rule_language_text": "taal is {name}",
  "mail_flow_rule_language_not_text": "taal is niet {name}",
  "mail_flow_rule_has_tag_text": "heeft tag {tag}",
  "mail_flow_rule_has_tag_not_text": "heeft tag {tag} niet",
  "mail_flow_rule_days_lt_text": "minder dan {n} dag tot het bezoek | minder dan {n} dagen tot het bezoek",
  "mail_flow_rule_days_lte_text": "hooguit {n} dag tot het bezoek | hooguit {n} dagen tot het bezoek",
  "mail_flow_rule_days_gt_text": "meer dan {n} dag tot het bezoek | meer dan {n} dagen tot het bezoek",
  "mail_flow_rule_days_gte_text": "minstens {n} dag tot het bezoek | minstens {n} dagen tot het bezoek",
  "mail_flow_rule_not_prefix": "niet {text}",

  // tag panel
  "mail_flow_tag_add_label": "Tags erbij",
  "mail_flow_tag_remove_label": "Tags eraf",
  "mail_flow_tag_hint": "De bezoeker krijgt de tag in je bezoekerslijst. Staat die er nog niet in, dan slaan we deze stap over.",
  "mail_flow_tag_name": "Tag",
  "mail_flow_tag_placeholder": "bijvoorbeeld vip",

  // notify panel
  "mail_flow_notify_text_nl": "Tekst (Nederlands)",
  "mail_flow_notify_text_en": "Tekst (Engels)",
  "mail_flow_notify_hint": "Je team krijgt dit als melding, met de naam en het mailadres van de bezoeker en een link naar de bestelling. Hoe vaak je meldingen krijgt stel je zelf in.",
  "mail_flow_notify_settings": "Naar je meldingen",

  // exit panel
  "mail_flow_exit_hint": "Hier stopt de automatische mail voor deze persoon. Er komt daarna niks meer.",

  // trigger
  "mail_flow_trigger_label": "Wanneer begint het?",
  "mail_flow_trigger_order_paid": "Iemand koopt tickets",
  "mail_flow_trigger_reservation_created": "Er wordt een reservering gemaakt",
  "mail_flow_trigger_first_scan": "Een ticket wordt voor het eerst gescand",
  "mail_flow_trigger_signup_confirmed": "Iemand meldt zich aan voor je nieuws",
  "mail_flow_trigger_tag_added": "Iemand krijgt een tag",
  "mail_flow_trigger_event_published": "Je publiceert een nieuwe activiteit",
  "mail_flow_trigger_manual": "Je zet zelf mensen erin",
  "mail_flow_trigger_order_paid_sentence": "Als iemand tickets koopt",
  "mail_flow_trigger_reservation_created_sentence": "Als er een reservering wordt gemaakt",
  "mail_flow_trigger_first_scan_sentence": "Als een ticket voor het eerst gescand wordt",
  "mail_flow_trigger_signup_confirmed_sentence": "Als iemand zich aanmeldt voor je nieuws",
  "mail_flow_trigger_tag_added_sentence": "Als iemand de tag {tag} krijgt",
  "mail_flow_trigger_event_published_sentence": "Als je een nieuwe activiteit publiceert",
  "mail_flow_trigger_manual_sentence": "Als je zelf mensen erin zet",
  "mail_flow_trigger_order_paid_hint": "Zodra een bestelling betaald is. Wie alles terugbetaald krijgt, valt er vanzelf uit.",
  "mail_flow_trigger_reservation_created_hint": "Zodra je een reservering met betaallink maakt, nog voor er betaald is.",
  "mail_flow_trigger_first_scan_hint": "Bij de eerste scan van een bestelling, dus één keer per bestelling, ook als er meer tickets in zitten.",
  "mail_flow_trigger_signup_confirmed_hint": "Als iemand zich via je formulier aanmeldt en dat in de bevestigingsmail bevestigt.",
  "mail_flow_trigger_tag_added_hint": "Zodra een bezoeker deze tag krijgt.",
  "mail_flow_trigger_event_published_hint": "Alle bezoekers die toestemming gaven voor nieuwsmail komen erin.",
  "mail_flow_trigger_manual_hint": "Niemand komt er vanzelf in: je zet zelf een groep bezoekers in de automatische mail.",
  "mail_flow_trigger_live_hint": "Wat je hier aanpast, gaat pas in als je het live zet. Welke activiteiten meedoen, geldt meteen.",
  "mail_flow_filter_title": "Alleen voor",
  "mail_flow_filter_intro": "Laat leeg om iedereen mee te nemen.",
  "mail_flow_filter_events": "Activiteiten",
  "mail_flow_filter_ticket_types": "Tickettypes",
  "mail_flow_filter_channels": "Hoe er besteld is",
  "mail_flow_filter_languages_label": "Talen",
  "mail_flow_filter_min_days_label": "Vroeg besteld",
  "mail_flow_filter_min_days_suffix": "dagen of meer voor het bezoek",
  "mail_flow_filter_min_days_hint": "Handig voor een extra herinnering aan wie lang van tevoren bestelde. Kijkt naar het tijdslot van de bestelling.",
  "mail_flow_all_events": "Alle activiteiten",
  "mail_flow_all_ticket_types": "Alle tickettypes",
  "mail_flow_all_channels": "Alle manieren",
  "mail_flow_all_languages": "Alle talen",
  "mail_flow_no_ticket_types": "Geen tickettypes gevonden",
  "mail_flow_not_set": "—",
  "mail_flow_filter_for_events": "voor {names}",
  "mail_flow_filter_with_ticket_types": "met ticket {names}",
  "mail_flow_filter_via_channels": "via {names}",
  "mail_flow_filter_min_days": "minstens {n} dag vooraf besteld | minstens {n} dagen vooraf besteld",
  "mail_flow_filter_languages": "in het {names}",
  "mail_flow_channel_shop": "de shop",
  "mail_flow_channel_import": "import",
  "mail_flow_channel_api": "de API",
  "mail_flow_channel_swapped": "TicketSwap",
  "mail_flow_channel_reservation": "een reservering",
  "mail_flow_channel_waitlist": "de wachtlijst",
  "mail_flow_channel_guest": "de gastenlijst",
  "mail_flow_channel_pos": "de kassa",
  "mail_flow_channel_moved": "verplaatste tickets",


  // publish errors
  "mail_flow_error_unknown": "Dat lukte niet. Probeer het nog eens, en werkt het dan nog niet, laat het ons weten.",
  "mail_flow_error_not_allowed": "Je hebt geen recht om automatische mails live te zetten.",
  "mail_flow_error_mail_flow_not_found": "Deze automatische mail bestaat niet meer.",
  "mail_flow_error_mail_flow_step_without_id": "Een stap is niet goed opgeslagen. Haal de laatste stap weg en voeg hem opnieuw toe.",
  "mail_flow_error_mail_flow_duplicate_step_id": "Er staat een stap dubbel in. Haal er een weg en voeg hem opnieuw toe.",
  "mail_flow_error_mail_flow_unknown_step": "Er zit een stap in die we niet kennen. Verwijder hem en probeer het opnieuw.",
  "mail_flow_error_mail_flow_if_not_last": "Na een 'Als…' kan niks meer komen, alleen in Ja of Nee. Zet de stappen eronder in een van de twee.",
  "mail_flow_error_mail_flow_send_without_template": "Bij een van de mails is nog geen mail gekozen.",
  "mail_flow_error_mail_flow_wait_too_long": "Een wachtstap duurt hooguit 365 dagen.",
  "mail_flow_error_mail_flow_too_many_steps": "Een automatische mail heeft maximaal 25 stappen. Haal er een paar weg.",
  "mail_flow_error_mail_flow_too_many_sends": "Een automatische mail stuurt maximaal 8 mails. Haal er een paar weg.",
  "mail_flow_error_mail_flow_unknown_template": "Een van de gekozen mails bestaat niet meer. Kies een andere.",

  // event page
  "mail_flow_event_title": "Automatische mails",
  "mail_flow_event_intro": "Welke mails bezoekers van deze activiteit vanzelf krijgen.",
  "mail_flow_event_classic": "Je gebruikt nog de standaard ticketmails, dus er lopen geen automatische mails.",
  "mail_flow_event_classic_link": "Lees wat eigen mails je geven",
  "mail_flow_event_only_this": "Alleen deze activiteit",
  "mail_flow_event_all": "Alle automatische mails bekijken",
}
